var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1C12.7761 1 13 1.22386 13 1.5V6C13 7.65685 14.3431 9 16 9H20.5C20.7761 9 21 9.22386 21 9.5V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4C3 2.34315 4.34315 1 6 1H12.5ZM13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V15.5858L9.70711 14.2929C9.31658 13.9024 8.68342 13.9024 8.29289 14.2929C7.90237 14.6834 7.90237 15.3166 8.29289 15.7071L11.2929 18.7071C11.6834 19.0976 12.3166 19.0976 12.7071 18.7071L15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929C15.3166 13.9024 14.6834 13.9024 14.2929 14.2929L13 15.5858V12ZM15 1.17157C15 1.07682 15.0768 1 15.1716 1C15.702 1 16.2107 1.21071 16.5858 1.58579L20.4142 5.41421C20.7893 5.78929 21 6.29799 21 6.82843C21 6.92318 20.9232 7 20.8284 7H16C15.4477 7 15 6.55228 15 6V1.17157Z",
    fill: "#C40808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadRed);
export default __webpack_public_path__ + "static/media/download-red.43e2a39b153f9360d2f84e245cd223e2.svg";
export { ForwardRef as ReactComponent };